import { DDI } from "callable-data-objects";
import { MenuSearch } from "Components/Shared";
import { useNumberPool } from "Hooks/Endpoints";
import React from "react";
import { Button, Container, Icon, Menu, Table } from "semantic-ui-react";
import ConfirmSelectNumber from "./ConfirmSelectNumber";

type AssignNumberProps = {
  onBack: Function;
  onComplete: Function;
};

const AssignNumberForm = ({ onBack, onComplete }: AssignNumberProps) => {
  const { ddis, ddi, search, select, filter } = useNumberPool();

  if (ddi) {
    return (
      <ConfirmSelectNumber
        onAssign={() => {
          search("");
          onComplete();
        }}
      />
    );
  }

  return (
    <Container textAlign='left' fluid>
      <Menu fluid stackable>
        <Menu.Item header onClick={() => onBack()}>
          <Icon name='x' />
        </Menu.Item>
        <Menu.Item header>Assign a new number from pool</Menu.Item>
        <Menu.Menu position='right'>
          <MenuSearch
            placeholder='Search...'
            onSearch={(value: string) => search(value)}
            value={filter?.name}
          />
        </Menu.Menu>
      </Menu>
      <Table celled padded stackable>
        <Table.Header>
          <Table.Row>
            <Table.HeaderCell width={15} singleLine>
              Number
            </Table.HeaderCell>
            <Table.HeaderCell width={1}>Actions</Table.HeaderCell>
          </Table.Row>
        </Table.Header>
        <Table.Body>
          {ddis &&
            ddis.content.map((ddi: DDI) => (
              <Table.Row key={`tr-ddi-${ddi.name}`}>
                <Table.Cell singleLine>{ddi.name}</Table.Cell>
                <Table.Cell textAlign='left'>
                  <Button primary size='tiny' onClick={() => select(ddi.id)}>
                    Select
                  </Button>
                </Table.Cell>
              </Table.Row>
            ))}
        </Table.Body>
      </Table>
    </Container>
  );
};

export default AssignNumberForm;
